exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".nxQKARsB3pJUXVj3W3xEx{border:.07143rem solid #174361;-webkit-border-radius:.35714rem;-moz-border-radius:.35714rem;border-radius:.35714rem;font-size:.85714rem;margin-right:.71429rem;padding:.21429rem}._3As9ckad6lw60UZ8T7zyQP,.V5AjpnjaYhOv1d2qSR2bm{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex}._3As9ckad6lw60UZ8T7zyQP{border-right:.07143rem solid #174361;padding:.5rem .35714rem .5rem .71429rem}._3As9ckad6lw60UZ8T7zyQP._3k5ZKNo5gWN-ryE_367tS5{border-color:#de4c4c}._3As9ckad6lw60UZ8T7zyQP._29vwlZR4t8V2sMlFNDG0L6{color:#174361}.V5AjpnjaYhOv1d2qSR2bm{padding:.5rem .71429rem .5rem .35714rem}.A-7c0U9WcPjvx2WoJ1LVl{display:-webkit-inline-box;display:-webkit-inline-flex;display:-moz-inline-box;display:-ms-inline-flexbox;display:inline-flex;margin-left:.35714rem}.nxQKARsB3pJUXVj3W3xEx._3k5ZKNo5gWN-ryE_367tS5{border-color:#de4c4c;color:#de4c4c}.nxQKARsB3pJUXVj3W3xEx._29vwlZR4t8V2sMlFNDG0L6{border-color:#174361;color:#174361}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"AcademicOverviewBadge": "nxQKARsB3pJUXVj3W3xEx",
	"AcademicOverviewBadge_info": "_3As9ckad6lw60UZ8T7zyQP",
	"AcademicOverviewBadge_profile": "V5AjpnjaYhOv1d2qSR2bm",
	"__warning": "_3k5ZKNo5gWN-ryE_367tS5",
	"__info": "_29vwlZR4t8V2sMlFNDG0L6",
	"AcademicOverviewBadge_icon": "A-7c0U9WcPjvx2WoJ1LVl"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./components/AcademicOverviewBadge/style.postcss
// module id = 2082
// module chunks = 0